/**
 * Every `action` string passed to `logAuditEvent` in ignite-ops-portal-backend.
 * Update this when new audit events are added (see logAuditEvent call sites).
 */
export const KNOWN_AUDIT_ACTIONS: readonly string[] = [
  'ADMIN_ACCESS_DENIED',
  'ADMIN_ACCESS_GRANTED',
  'KB_ARTICLE_CREATED',
  'KB_ARTICLE_DELETED',
  'KB_ARTICLE_UPDATED',
  'KB_TAG_CREATED',
  'KB_TAG_DELETED',
  'KB_TAG_UPDATED',
  'ROLE_CREATED',
  'ROLE_DELETED',
  'ROLE_UPDATED',
  'USER_CREATED',
  'USER_UPDATED',
];
